import React, { useRef, useEffect } from "react"
import "./ConsoleOutput.css"

const ConsoleOutput = (props: { text: string }) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.scrollTop = textAreaRef.current.scrollHeight //scroll to bottom
    }
  })

  return (
    <textarea
      className="console-output"
      readOnly={true}
      value={props.text}
      ref={textAreaRef}
    />
  )
}

export default ConsoleOutput
